import { FC } from 'react'
import { Box } from '@mui/material'
import { MainButton } from '@eventr/common-storybook'
import i18n from '../../../i18n/i18next'
import { PriceRangeFilter } from './priceRangeFilter'
import { StarRatingFilter } from './starRatingFilter'
import { GuestReviewsFilter } from './guestReviewFilter'
import { CurrencySelector } from './currencySelector'

type TFiltersDrawerProps = {
    close: () => void
}

export const FiltersDrawer: FC<TFiltersDrawerProps> = ({ close }) => {
    return (
        <Box display={'grid'} width={'100%'}>
            <Box height={'16px'} />
            <Box display={'grid'} gap={'8px'}>
                <CurrencySelector />
                <PriceRangeFilter />
                <StarRatingFilter />
                <GuestReviewsFilter />
            </Box>
            <Box height={'16px'} />
            <MainButton text={i18n.t('general.done')} onClick={close} />
            <Box height={'32px'} />
        </Box>
    )
}
